import { HIDE_MESSAGE, SHOW_MESSAGE } from '~/actions';
import { IMessageState, IPopupProps, TMessageAction } from './interface';

const initialState: IMessageState = {
  message: {
    action: null,
    isError: null,
    isSuccess: null,
    params: null,
    popupProps: {} as IPopupProps,
    route: null,
    text: null,
    title: null,
    buttonText: null,
  },
};

export default (state: IMessageState = initialState, action: TMessageAction): IMessageState => {
  const { type } = action;

  switch (type) {
    case SHOW_MESSAGE: {
      const { message, title, route, params, isSuccess, isError, popupProps, buttonText } =
        action.payload;

      return {
        ...state,
        message: {
          action: action.payload?.action,
          text: message,
          title,
          route,
          params,
          isSuccess,
          isError,
          popupProps,
          buttonText,
        } as IMessageState['message'],
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...initialState,
      };
    }
    default:
      return { ...state };
  }
};
